<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 第一行：图片上传 -->
          <div class="modal-row">
            <label>工具图片</label>
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleAvatarUpload"
            >
              <img v-if="localInstrInfo.imageUrl" :src="localInstrInfo.imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          
          <!-- 第二行：工具描述（两列布局） -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>工具描述</label>
            </div>
            <div class="column">
              <el-input  el-input 
                v-model="localInstrInfo.desc" 
                placeholder="请输入工具描述"
              ></el-input>
            </div>
          </div>

          <!-- 第二行：工具描述（两列布局） -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>跳转连接</label>
            </div>
            <div class="column">
              <el-input  el-input 
                v-model="localInstrInfo.link" 
                placeholder="请输入跳转链接"
              ></el-input>
            </div>
          </div>

          <!-- 第二行：工具描述（两列布局） -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>组件变量名，链接非空时必填</label>
            </div>
            <div class="column">
              <el-input  el-input 
                v-model="localInstrInfo.showComponent" 
                placeholder="请输入变量名称"
              ></el-input>
            </div>
          </div>
          
          <!-- 第三行：工具类别（两列布局） -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>工具类别</label>
            </div>
            <div class="column" style="z-index: 1001 !important">
              <el-select style="z-index: 1001 !important"
                v-model="localInstrInfo.typeId" 
                placeholder="请选择工具类别"
                class="category-select"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="modal-row two-columns">
            <div class="column">
              <label>状态管理</label>
            </div>
            <div class="column">
              <select v-model="localInstrInfo.status" class="status-select">
                <option value="0">正常</option>
                <option value="1">禁用</option>
              </select>
            </div>
          </div>
          
          <!-- 第四行：操作按钮 -->
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交数据</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';

import { getInstrTypeList, saveInstrInfo } from '@/api/instr';


export default {
  name: 'CreateInstr',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    InstrInfo: {
      type: Object,
      default: () => ({
        id: null,
        desc: '',
        typeId: null,
        link: '',
        enableJump: null,
        showComponent: '',
        status: '',
        imageUrl: '',
        imageFile: null
      })
    },
    
  },
  data() {
    return {
      localInstrInfo: {
        ...this.InstrInfo,
        imageUrl: '', // 确保有初始化
        imageFile: null
      },
      categoryOptions: []
    }
  },
  mounted(){
    this.queryInstrTypeList();
  },
  methods: {
    closeModal() {
      this.clearForm();
      this.isVisible = !this.isVisible;
      this.$emit('update:visible', false);
    },
    clearForm() {
      this.localInstrInfo = {
        id: null,
        desc: '',
        typeId: '',
        status: '',
        showComponent: '',
        imageUrl: '',
        imageFile: null
      }
    },
    async queryInstrTypeList(){
      const params = {};
        try{
            const resp = await getInstrTypeList(params);
            if (resp.code === 200 && resp.success && resp.data != []) {
              this.categoryOptions = resp.data;
            } else {
              Message.error(resp.msg || '获取工具类别类别接口失败');
            }
      } catch (error) {
        Message.error('请求失败: ' + error.msg);
      }
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes('image/');
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isImage) {
        Message.error('只能上传图片文件!');
      }
      if (!isLt2M) {
        Message.error('图片大小不能超过10MB!');
      }

      return isImage && isLt2M;
    },
    handleAvatarUpload({ file }) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.localInstrInfo.imageUrl = e.target.result;
        this.localInstrInfo.imageFile = file;
      };
      reader.readAsDataURL(file);
    },
    async submitForm() {
      if (!this.localInstrInfo.desc) {
        Message.error('请填写工具描述');
        return;
      }
      if (!this.localInstrInfo.typeId) {
        Message.error('请选择工具类别');
        return;
      }

      const formData = new FormData();
      const instrInfo = {
        id: this.localInstrInfo.id,
        desc: this.localInstrInfo.desc,
        typeId: this.localInstrInfo.typeId,
        link: this.localInstrInfo.link,
        enableJump: this.localInstrInfo.enableJump,
        status: this.localInstrInfo.status,
        showComponent: this.localInstrInfo.showComponent,
        order: 0,
        updateImg: false
      }
      formData.append('instrInfo', JSON.stringify(instrInfo));
      
      if (this.localInstrInfo.imageFile) {
        formData.append('file', this.localInstrInfo.imageFile);
      }
      
      const configParams = {headers: {
        'Content-Type': 'multipart/form-data'
      }}

      try {
        const resp = await saveInstrInfo(formData, configParams);
        if (resp.code === 200 && resp.success) {
          Message.success('操作成功！');
          this.$emit('saved', resp.data);
          this.closeModal();
        } else {
          Message.error(resp.msg || '操作失败');
        }
      } catch (error) {
        Message.error('请求失败: ' + error.msg);
      }
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.status-select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

@media(max-width: 768px){
.modal-container {
  width: 90% !important;
  padding: 6px !important;
}
}

.modal-container {
  width: 50%;
  min-height: 60%;
    /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.6);
  /* 提高透明度 */
  backdrop-filter: blur(16px) saturate(180%);
  /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
  margin-bottom: 20px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.column:first-child {
  margin-right: 15px;
  min-width: 100px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.category-select {
  width: 100%;
}

/* 过渡动画 */
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>